import { createContext, FC, PropsWithChildren, useContext, useMemo, useState } from 'react'
import { ConsentFormSettingsModal } from './ConsentForms/ConsentFormSettings'

interface TemplatesViewContextType {
  editingConsentFormSettings: string | null
  editConsentFormSettings: (id: string) => void
  closeConsentFormSettings: () => void
}

const TemplatesViewContext = createContext<TemplatesViewContextType>({
  editingConsentFormSettings: null,
  editConsentFormSettings: () => {},
  closeConsentFormSettings: () => {},
})

export const TemplatesViewProvider: FC<PropsWithChildren> = ({ children }) => {
  const [editingConsentFormSettings, setEditingConsentFormSettings] = useState<string | null>(null)
  const contextValue = useMemo(
    () => ({
      editingConsentFormSettings,
      editConsentFormSettings: (id: string) => setEditingConsentFormSettings(id),
      closeConsentFormSettings: () => setEditingConsentFormSettings(null),
    }),
    [editingConsentFormSettings],
  )
  return (
    <TemplatesViewContext.Provider value={contextValue}>
      {children}
      <ConsentFormSettingsModal
        practiceId={null}
        consentFormId={editingConsentFormSettings}
        onClose={contextValue.closeConsentFormSettings}
      />
    </TemplatesViewContext.Provider>
  )
}

export const useTemplatesView = () => useContext(TemplatesViewContext)
